var map = {
	"./answers.svg": "50cc",
	"./cart.svg": "c0c3",
	"./close.svg": "bb7c",
	"./closeIcon.svg": "e8d7",
	"./favorite.svg": "42da",
	"./help-circle.svg": "da56",
	"./sort_arrow.svg": "d0ef",
	"./tool.svg": "e461"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";